import { ButtonMultiSelectControlContent } from '../ButtonMultiSelectControlContent'
import { ButtonSelectControl } from '../ButtonSelectControl'
import { SelectControlSelectedItemsCounter } from '../SelectControlSelectedItemsCounter'

function ButtonMultiSelectControl({ indicatorsProps, ref, ...restProps }) {
  return (
    <ButtonSelectControl
      {...restProps}
      Content={ButtonMultiSelectControlContent}
      indicatorsProps={{
        ...indicatorsProps,
        SelectedItemsCounter:
          indicatorsProps?.SelectedItemsCounter !== undefined
            ? indicatorsProps.SelectedItemsCounter
            : SelectControlSelectedItemsCounter,
      }}
      ref={ref}
    />
  )
}

export default ButtonMultiSelectControl
